<template>
  <div class="container">
    <div
      id="carouselSlidesBienvenida"
      class="carousel slide "
      data-ride="carousel"
      data-interval="99000"
    >    
      <ol class="carousel-indicators">
        <li
          data-target="#carouselSlidesBienvenida"
          :data-slide-to="index"
          v-for="(slide, index) in slides"
          :key="'slideDashboardControls' + index"
          :class="index == 0 ? ' active' : ''"
        ></li>
      </ol>
      <div class="row">
        <div class="progress w-100">
          <div
            class="progress-bar"
            role="progressbar"
            :style="'width:' + porcentajeBar + '%'"
            :aria-valuenow="porcentajeBar"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
      </div>
      <div class="carousel-inner ">
        <div
          :class="'carousel-item' + (index == 0 ? ' active' : '')"
          v-for="(slide, index) in slides"
          :key="'slideDashboard' + index"
        >
          <div class="ql-viewer ql-editor" v-html="slide.contenido_slide">
            {{ slide.contenido_slide }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["slides"],
  data() {
    return {
      currentSlide: 1,
    };
  },
  computed: {
    porcentajeBar() {
      return (100 / this.slides.length) * this.currentSlide + 1;
    },
  },
  async mounted() {
    let that = this;
    $("#carouselSlidesBienvenida").carousel({ interval: false, keyboard: false, touch: false });
    await $("#carouselSlidesBienvenida").on("slid.bs.carousel", function () {
      that.currentSlide =
        $("#carouselSlidesBienvenida .carousel-item.active").index() + 1;
      that.$emit("setModuloActual", that.slides[that.currentSlide - 1]["tipo"]);
    });
  },
};
</script>

<style scoped>
.carousel-control-prev-icon,
.carousel-control-next-icon {
  background-image: none;
}

.carousel-control-prev,
.carousel-control-next {
  width: fit-content;
  right: 3em;
}

.carousel-control-prev-icon i,
.carousel-control-next-icon i {
  color: #7d7d7d;
  font-size: 2em;
}
.carousel-indicators {
  bottom: -2em;  
}
.carousel-indicators li {
  background-color: #7d7d7d;
}
.carousel-indicators li.active {
  background-color: #303030;
}
.carousel-item {
  max-height: 65vh !important;
  height: 65vh !important;
  overflow-y: auto;
  padding-bottom: 1em;
}

.ql-viewer::-webkit-scrollbar {
  width: 5px;
}

.ql-viewer::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #7d7d7d6e;
  border-radius: 10px;
}

/* Handle */
.ql-viewer::-webkit-scrollbar-thumb {
  background: #4d4d4d4d;
  border-radius: 10px;
}
.carousel-indicators li {
  width: 10px;
  height: 10px;
  border-radius: 2em !important;
  border-style: hidden;
}

.progress-bar{
  background-color: #FF9900;
}
</style>


// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/SlidesBienvenida.vue